module.exports = __webpack_public_path__ + "media/images/home/cover-mobile@3x-450452e73e3aac0d94bda5205973fde7.jpg";